import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';
import { Box } from '../Box/Box';
import { Text } from '../Text/Text';
import { Type } from '../Type/Type';

var Quote = function Quote(_ref) {
  var text = _ref.text,
      hasAttribution = _ref.hasAttribution;
  return /*#__PURE__*/React.createElement(Box, {
    component: "blockquote",
    position: "relative",
    marginBottom: hasAttribution ? '2' : undefined
  }, /*#__PURE__*/React.createElement(Type, _extends({
    inline: true,
    size: 4,
    fontFamily: "chronicle"
  }, mergeStyles(baseStyles('position-absolute'), {
    style: {
      right: '100%'
    }
  })), "\u201C"), /*#__PURE__*/React.createElement(Type, {
    inline: true,
    size: 4,
    fontFamily: "chronicle"
  }, text, /*#__PURE__*/React.createElement(Type, {
    inline: true
  }, "\u201D")));
};

var Attribution = function Attribution(_ref2) {
  var text = _ref2.text;
  return /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, text);
};

/**
 * Distinguishes quoted text in a document by increasing the size of the quote, giving it an attribution, and adding a border around it.
 */
export var BlockQuote = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var quote = _ref3.quote,
      _ref3$attribution = _ref3.attribution,
      attribution = _ref3$attribution === void 0 ? null : _ref3$attribution;
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-currency": "BlockQuote",
    paddingLeft: "4"
  }, mergeStyles(baseStyles('max-width-prose-wide')), {
    ref: ref
  }), /*#__PURE__*/React.createElement(Quote, {
    text: quote,
    hasAttribution: !!attribution
  }), attribution && /*#__PURE__*/React.createElement(Attribution, {
    text: attribution
  }));
});
BlockQuote.displayName = 'BlockQuote';